const ImageSwiper = class extends HTMLElement {
  constructor () {
    super()

    this.thumbsSwiper = this.querySelector('[data-image-swiper-thumbs]')
    this.mainSwiper = this.querySelector('[data-image-swiper-main]')
    this.modalCloseBtn = this.querySelector('[data-image-swiper-modal-close]')

    this.initSwiper()
  }

  /**
   * Initializes all swiper functionality
   */
  initSwiper () {
    const thumbsSwiper = new Swiper(this.thumbsSwiper, {
      spaceBetween: 16,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        600: {
          slidesPerView: 9
        },
        1000: {
          slidesPerView: 4
        },
        1200: {
          slidesPerView: 9
        }
      }
    })

    const mainSwiper = new Swiper(this.mainSwiper, {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: thumbsSwiper,
      }
    })

    this.mainSwiper.addEventListener('click', (event) => {
      if (event.target.classList.contains('product-recipe__instructions-step-image')) {
        if (this.classList.contains('product-recipe__instructions-step-images--modal')) {
          this.classList.remove('product-recipe__instructions-step-images--modal')
          document.body.style.overflow = 'auto'
        } else {
          this.classList.add('product-recipe__instructions-step-images--modal')
          document.body.style.overflow = 'hidden'
        }
      }
    })

    this.modalCloseBtn.addEventListener('click', () => {
      document.body.style.overflow = 'auto'
      this.classList.remove('product-recipe__instructions-step-images--modal')
    })
  }
}

if (typeof window.customElements.get('image-swiper') === 'undefined') {
  window.customElements.define('image-swiper', ImageSwiper)
}
